import { RESOURCE_NAMES } from '@kaeliux/shared';

/**
 * Per-resource swatch color + label for the cost row in `BuildingPopover`.
 * Keys match `ResourceCost`'s fields (`packages/shared`). Colors are the
 * DS-17 mockup's fixed palette — not design tokens — so they live here as
 * the single source both the component and its test import.
 */
export const RESOURCE_SWATCHES = {
    metal: { color: '#a8d8ea', label: RESOURCE_NAMES.metal },
    minerals: { color: '#aa96da', label: RESOURCE_NAMES.minerals },
    gas: { color: '#fcbad3', label: RESOURCE_NAMES.gas },
    energy: { color: '#ffffd2', label: RESOURCE_NAMES.energy },
} as const;

export type SwatchResourceKey = keyof typeof RESOURCE_SWATCHES;
